import React from "react";
import { createPortal } from "react-dom";
import styles from "./Lightbox.module.css";

export type LightboxMediaItemType = {
    type: "image" | "video";
    src: string;
};

interface LightboxProps {
    media: LightboxMediaItemType;
    onClose: () => void;
}

const Lightbox: React.FC<LightboxProps> = ({ media, onClose }) => {
    return (
        createPortal(
            <div className={styles.lightboxOverlay} onClick={onClose}>
                <div className={styles.lightboxContent} onClick={(e) => e.stopPropagation()}>
                    <button className={styles.closeButton} onClick={onClose}>
                        &times;
                    </button>
                    {media.type === "image" ? (
                        <img src={media.src} alt="Enlarged view" className={styles.lightboxImage} />
                    ) : (
                        <video src={media.src} controls autoPlay className={styles.lightboxVideo}></video>
                    )}
                </div>
            </div>,
            document.body
        )
    );
};

export default Lightbox;
